export default "__VITE_ASSET__B8JzHXKV__"